export const ADD_CONNECTION_AS_PARTNER = '{connection-list}ADD_CONNECTION_AS_PARTNER';


export const addConnectionAsPartner = (connectionId, targetCompanyId) => ({
  type: ADD_CONNECTION_AS_PARTNER,
  payload: {
    connectionId,
    targetCompanyId,
  },
});



// WEBPACK FOOTER //
// ./src/app/components/connections/__storeFiles__/actions.js